export default {
  disabled: false
};